import * as React from "react";
import "./Page.css";

export interface IPageProps
{
    title: string;
}

export class Page extends React.Component<IPageProps, {}>
{
    public render()
    {
        return (
            <section className="page">
                <h1>
                    {this.props.title}
                </h1>
                <section>
                    {this.props.children}
                </section>
            </section>
        );
    }
}
